import axios, { handleResp } from "../config/axios";
import { toastError } from "../config/ToastModal";

// export const register = async (data) => {
//   try {
//     let respData = await axios({
//       url: `/user/register`,
//       method: "post",
//       data,
//     });

//     return handleResp(respData);
//   } catch (err) {
//     return handleResp(err.response);
//   }
// };

export const loginAuth = async (data) => {
  try {
    let respData = await axios({
      url: `/company/login`,
      method: "post",
      data,
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const googleAuth = async (data) => {
  try {
    let respData = await axios({
      url: `/company/google/auth`,
      method: "post",
      data,
    });

    console.log(respData, "respdata");

    return handleResp(respData);
  } catch (err) {
    console.log(err?.response?.data?.errors, "errpdata");
    toastError(err?.response?.data?.errors?.email);

    return handleResp(err.response);
  }
};
export const registerService = async (data) => {
  try {
    let respData = await axios({
      url: `/company/register`,
      method: "post",
      data,
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const socialMedia = async (data) => {
  try {
    let respData = await axios({
      url: `/company/update-social-media`,
      method: "post",
      data,
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const contactInfo = async (data) => {
  try {
    let respData = await axios({
      url: `/company/update-contact-information`,
      method: "post",
      data,
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};
export const myProfiles = async (data) => {
  try {
    let respData = await axios({
      url: `/company/update-profile`,
      method: "post",
      data,
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};
export const changePassword = async (data) => {
  try {
    let respData = await axios({
      url: `/company/change-password`,
      method: "post",
      data,
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};
export const jobPost = async (data) => {
  try {
    let respData = await axios({
      url: `/company/job-post`,
      method: "post",
      data,
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};
export const jobUpdate = async (data) => {
  try {
    let respData = await axios({
      url: `/company/job-post`,
      method: "put",
      data,
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const manageJobs = async (current) => {
  try {
    let respData = await axios({
      url: `/company/get-managejobs?page=${current}&limit=15`,
      method: "get",
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const allApplicant = async (data) => {
  try {
    let respData = await axios({
      url: `/company/applied-application`,
      method: "get",
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};
export const viewApplicant = async (data, id) => {
  try {
    let respData = await axios({
      url: `/company/single-application/${data}/${id}`,
      method: "get",
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};
export const approveList = async (data) => {
  try {
    let respData = await axios({
      url: `/company/shortlist-application`,
      method: "get",
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const rejectedList = async (data) => {
  try {
    let respData = await axios({
      url: `/company/rejected-application`,
      method: "get",
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};
export const shorListApp = async (data) => {
  try {
    let respData = await axios({
      url: `/company/shorted-application`,
      method: "post",
      data,
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const getProfile = async () => {
  try {
    let respData = await axios({
      url: `/company/get-profile`,
      method: "get",
    });
    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const getSingleJob = async (data) => {
  try {
    let respData = await axios({
      url: `company/get-single-jobs/`,
      method: "post",
      data,
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const ForgetMailServices = async (data) => {
  try {
    let respData = await axios({
      url: `/company/forgot-password`,
      method: "post",
      data,
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const ResetMailServices = async (data) => {
  try {
    let respData = await axios({
      url: `/company/reset-password`,
      method: "post",
      data,
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const GetExamUserLists = async (data) => {
  try {
    let respData = await axios({
      url: `/company/exam-list`,
      method: "get",
      data,
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const GetAllExamUserLists = async (data) => {
  try {
    let respData = await axios({
      url: `/company/exam-all-user-list`,
      method: "get",
      data,
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const GetSingleExamUserLists = async (examId, jobId) => {
  try {
    let respData = await axios({
      url: `/company/exam-user-list/${examId}/${jobId}`,
      method: "get",
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const GetDashboardList = async () => {
  try {
    let respData = await axios({
      url: `/company/job-post/dashboard`,
      method: "post",
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const GetJobCategories = async () => {
  try {
    let respData = await axios({
      url: `/company/category-all`,
      method: "get",
    });

    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const CategoryCreateCompany = async (data) => {
  try {
    let respData = await axios({
      url: `/company/category`,
      method: "post",
      data,
    });
    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

// langugae create

export const LanguageCreate = async (data) => {
  try {
    let respData = await axios({
      url: `/company/language`,
      method: "post",
      data,
    });
    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const LanguageGetCreate = async () => {
  try {
    let respData = await axios({
      url: `/company/language`,
      method: "get",
    });
    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const PhoneVerifyPost = async (data) => {
  try {
    let respData = await axios({
      url: `/company/profile/phone/verify`,
      method: "post",
      data,
    });
    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const PhoneVerifyPostResend = async (data) => {
  try {
    let respData = await axios({
      url: `/company/profile/phone/verify`,
      method: "post",
      data,
    });
    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const getCompanyMeeting = async () => {
  try {
    let respData = await axios({
      url: `/company/meeting`,
      method: "get",
    });
    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const validateMeeting = async (data) => {
  try {
    let respData = await axios({
      url: `/company/meeting`,
      method: "post",
      data,
    });
    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const endMeeting = async (data) => {
  try {
    let respData = await axios({
      url: `/company/meeting`,
      method: "patch",
      data,
    });
    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const audioUpload = async (data) => {
  try {
    let respData = await axios({
      url: `/company/meeting`,
      method: "put",
      data,
    });
    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const AddDocumentMSME = async (data) => {
  try {
    let respData = await axios({
      url: `/company/document-upload`,
      method: "post",
      data,
    });
    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const AddDocumentDetails = async (data) => {
  try {
    let respData = await axios({
      url: `/company/document-details`,
      method: "post",
      data,
    });
    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const dashboardDataHome = async () => {
  try {
    let respData = await axios({
      url: `/company/job-post/dashboard`,
      method: "post",
    });
    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const notification = async () => {
  try {
    let respData = await axios({
      url: `/company/get-notifications`,
      method: "get",
    });
    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const updateNotification = async () => {
  try {
    let respData = await axios({
      url: `/company/get-notifications`,
      method: "put",
    });
    return handleResp(respData);
  } catch (err) {
    return handleResp(err.response);
  }
};

export const SendChatMessage = async (data) => {
  try {
    let respData = await axios({
      url: `/company/chat`,
      method: "post",
      data,
    });
    return respData;
  } catch (err) {
    return handleResp(err.response);
  }
};

export const allMeetings = async (data) => {
  try {
    let respData = await axios({
      url: `/company/meeting?interviewType=${data}`,
      method: "get",
    });
    return respData;
  } catch (err) {
    return handleResp(err.response);
  }
};

export const resumeAiScanner = async (data) => {
  try {
    let respData = await axios({
      url: `/company/ai/rank-resumes`,
      method: "post",
      data,
    });
    return respData;
  } catch (err) {
    return handleResp(err.response);
  }
};

export const extraResumeAiScanner = async (data) => {
  try {
    let respData = await axios({
      url: `/company/ai/rank-resumes`,
      method: "put",
      data,
    });
    return respData;
  } catch (err) {
    return handleResp(err.response);
  }
};

export const resumeSingleMail = async (data) => {
  try {
    let respData = await axios({
      url: `/send-interview`,
      method: "post",
      data,
    });
    return respData;
  } catch (err) {
    return handleResp(err.response);
  }
};

export const candidateEdit = async (data) => {
  try {
    let respData = await axios({
      url: `/company/ai/edit-claudeResponse`,
      method: "post",
      data,
    });
    return respData;
  } catch (err) {
    return handleResp(err.response);
  }
};

export const resumeBulkMail = async (data) => {
  try {
    let respData = await axios({
      url: `/send-bulk-interviews`,
      method: "post",
      data,
    });
    return respData;
  } catch (err) {
    return handleResp(err.response);
  }
};

export const singleBatchData = async (data) => {
  try {
    let respData = await axios({
      url: `/company/ai/batchDetailsOverview`,
      method: "post",
      data,
    });
    return respData;
  } catch (err) {
    return handleResp(err.response);
  }
};

export const resumeUploadList = async () => {
  try {
    const response = await axios.get("/company/ai/batchDetailsList");
    return response
  } catch (err) {
    return handleResp(err?.response || err);
  }
};

export const interviewMail = async (data) => {
  try {
    let respData = await axios({
      url: `/company/ai/interview-mail`,
      method: "post",
      data,
    });
    return respData;
  } catch (err) {
    return handleResp(err.response);
  }
};

export const getQuestionId = async (data) => {
  try {
    let respData = await axios({
      url: `/company/ai/batch-question/${data}`,
      method: "get",
    });
    return respData;
  } catch (err) {
    return handleResp(err.response);
  }
};

export const editQuestion = async (data) => {
  try {
    let respData = await axios({
      url: `/company/ai/edit-batchQuestion`,
      method: "post",
      data,
    });
    return respData;
  } catch (err) {
    return handleResp(err.response);
  }
};

export const deleteQuestion = async (data) => {
  try {
    let respData = await axios({
      url: `/company/ai/remove-batchQuestion`,
      method: "post",
      data,
    });
    return respData;
  } catch (err) {
    return handleResp(err.response);
  }
};

export const addQuestion = async (data) => {
  try {
    let respData = await axios({
      url: `/company/ai/add-batchQuestion`,
      method: "post",
      data,
    });
    return respData;
  } catch (err) {
    return handleResp(err.response);
  }
};

export const getVideoCall = async (data) => {
  try {
    let respData = await axios({
      url: `/company/ai/call/${data}`,
      method: "get",
    });
    return respData;
  } catch (err) {
    return handleResp(err.response);
  }
};
